module.exports = __webpack_public_path__ + "images/a45f4137f8dcee1a9110942ac3bae683-Couples-Resorts-Logo-Centered.jpg";